import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Card, Checkbox, Container, Dropdown, Grid, Icon, Popup, Select} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import CommercialTable from '../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../manageOrders/components/internalCommons/TableFilters';
import {getDropdownOptions} from '../../../common/util/dropdown';
import {Link} from 'react-router-dom';
import {paths} from '../../../common/dictionaries/urls';
import {replace} from 'lodash';
import WtsCourseTechDetailsModal from './course/courseTechDetailsModal';

const {
  getWtsCourses,
  changeWtsAreaSelected,
  getWtsAreas,
  deleteWtsCourse,
} = Actions;

const WtsCourses = () => {
  const {areas, areaSelected} = useSelector((state) => state.wtsAreas);
  const {courses, loading} = useSelector((state) => state.wtsCourses);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getWtsAreas());
  }, [dispatch]);

  useEffect(() => {
    if (areaSelected?.id) {
      dispatch(getWtsCourses({'area': areaSelected.id}));
    }
  }, [areaSelected, dispatch]);

  const onChangeWtsAreaSelected = (e, {value}) => {
    e.preventDefault();
    const selected = areas.find((x) => x.id === value);
    if (selected) {
      dispatch(changeWtsAreaSelected(selected));
    }
  };

  const updateStatus = (e, checkedValue, item) => {
    e.preventDefault();
    dispatch(deleteWtsCourse(item.id,
      {...item, 'status': checkedValue ? 'ACTIVO' : 'INACTIVO'}));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'ACTIVO', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'INACTIVO', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%', 'color': filterValue ? 'black' : 'grey'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
        }}
      />
    );
  };

  const filteredCourses = useMemo(() => {
    return (courses || []).filter((course) => course.statusArea === 'A');
  }, [courses]);

  const columns = useMemo(() => [
    {
      'Header': () => <span className="header-title">CÓDIGO</span>,
      'accessor': 'reference',
    },
    {
      'Header': () => <span className="header-title">AREA</span>,
      'accessor': 'courseArea',
    },
    {
      'Header': () => <span className="header-title">TÍTULO</span>,
      'accessor': 'course',
    },
    {
      'Header': () => <span className="header-title">OBSERVACIÓN</span>,
      'accessor': 'courseObservation',
      'width': 1,
      'Cell': (row) => <Popup
        trigger={<Icon className='i comment keep-color-on-hover' size='big' color='red' />}
        content={<div>{row.value}</div>}
      />,
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => {
        return loading ? <Icon loading name='spinner' /> :
          <Checkbox toggle checked={item.value === 'ACTIVO' || item.value === 'A'} className='green'
            onChange={(e, input) => updateStatus(e, input.checked, item.row.original)} />;
      },
    },
    {
      'Header': () => 'ACCIONES',
      'id': 'courses_actions',
      'width': 1,
      'disableFilters': true,
      'Cell': ({row}) => {
        return <div className='flex center end'>
          <Link to={replace(paths.WtsCourseEdit, ':courseId', row.original.id)}>
            <Icon size='big' name='pencil' link color="green" className='keep-color-on-hover' />
          </Link>
        </div>;
      },
    },
  ], [loading, areaSelected]);

  return (
    <Container fluid>
      <Card raised fluid style={{'backgroundColor': 'transparent'}}>
        <div className='title-bar' style={{'display': 'flex', 'alignItems': 'center',
          'padding': '10px', 'position': 'relative'}}>
          <div className='title'>
            <h2 style={{'margin': '0'}}>Mantenimiento de Cursos</h2>
          </div>
          <div style={{'position': 'absolute', 'right': '10px', 'top': '50%', 'transform': 'translateY(-50%)'}}>
            <WtsCourseTechDetailsModal />
          </div>
        </div>
        <div className='title-bar'>
          <Grid>
            <Grid.Row textAlign='left'>
              <Grid.Column width={5}>
                <div className="ui fluid labeled input">
                  <div className="ui label label">Área de capacitación</div>
                  <Dropdown fluid selection labeled className='labeled-dropdown'
                    value={areaSelected?.id} onChange={(e, i) => onChangeWtsAreaSelected(e, i)}
                    options={getDropdownOptions(areas, 'id', 'description')} />
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Card>
      <Card raised fluid>
        <Grid padded>
          <Grid.Row>
            <Grid.Column width={1} style={{'paddingBottom': '20px'}}>
              <Button
                as={Link}
                to={paths.WtsCourseNew}
                style={{
                  'backgroundColor': '#ffffff',
                  'border': '1px solid #e0e1e2',
                  'color': '#000000',
                  'display': 'inline-flex',
                  'alignItems': 'center',
                }}
              >
                <Icon link name='add-circle' size='big' color='green' />
                Añadir
              </Button>
            </Grid.Column>
            <Grid.Column width={16}>
              <CommercialTable
                columns={columns}
                data={filteredCourses}
                defaultColumnFilter={DefaultColumnFilter}
                pagination={true}
                defaultPagination={10}
                hoverActive={false}
                initialState={{
                  'filters': [
                    {
                      'id': 'status',
                      'value': '',
                    },
                  ],
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    </Container>
  );
};

export default WtsCourses;
